import {
  createContext,
  PropsWithChildren,
  useEffect,
  useMemo,
  useState
} from 'react'

import Theme, { ThemeProps } from './theme'

export type Context = ThemeProps & {
  theme: {
    header: {
      variant: 'light' | 'dark'
    }
  }
  isDarkMode: boolean
  toggleDarkMode: () => void
}

export const ThemeContext = createContext<Context | undefined>(undefined)

// ✅ props che arrivano dall'esterno (NON includono isDarkMode/toggleDarkMode)
type ThemeProviderProps = PropsWithChildren<{
  theme: {
    header: {
      variant: 'light' | 'dark'
    }
  }
}>

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode')
    if (savedMode === 'true') {
      setIsDarkMode(true)
      document.documentElement.classList.add('dark')
    }
  }, [])

  const toggleDarkMode = () => {
    setIsDarkMode((prev) => {
      const newMode = !prev
      localStorage.setItem('darkMode', String(newMode))
      document.documentElement.classList.toggle('dark', newMode)
      return newMode
    })
  }

  const contextValue = useMemo(
    () => ({
      theme: theme as Context['theme'],
      isDarkMode,
      toggleDarkMode
    }),
    [theme, isDarkMode]
  )

  return (
    <ThemeContext.Provider value={contextValue}>
      <Theme />
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
